/**
 * 字符串转成数组
 * @param {*} inputString  逗号分割的字符串
 * @returns array
 */
export function getSeparatedData(inputString) {
  if (typeof inputString !== 'string') {
    return [];
  }
  if (inputString.trim() === '') {
    return [];
  }
  try {
    const separatedData = inputString.replace(/，/gi, ',').split(',').map(item => item.trim());
    return separatedData;
  } catch (error) {
    return [];
  }
}